import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import pages from './modules/pages'
import activity from './modules/activity'
import settings from './modules/settings'
import osc from './modules/osc'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

Vue.use(require('vue-moment'))
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    pages,
    activity,
    settings,
    osc
  },
  plugins: [vuexLocal.plugin]
})

export default store
